// Dependencies
import { combineReducers } from 'redux';

// Container Reducers
import authentication from '../../authentication/reducer';
import home from '../../home/reducer';
import settings from '../../settings/reducer';

// Shared Reducers


const rootReducer = combineReducers({
  authentication,
  home,
  settings
});

export default rootReducer;
